<template lang="pug">
  v-card.plans.body.inner-scroll
    portal(to='toolbar')
      v-toolbar-title Payments / Plans
    v-card
      .d-flex.px-3.py-3.align-center
        v-btn(fab color="primary" small @click="showPlanModal").ml-auto
          v-icon(small) $vuetify.icons.plus
    list(
      :loading="listLoading"
      :list="list"
      :pagination="pagination"
      :headers="headers"
      :sort-model="sortModel"
      hide-select
      multi-sort=false
      sortable
      v-slot="{item}"
      @loadMoreClick="loadListMore"
      @itemEditClick="editPlan"
      @removeClicked="deletePlan"
      delete-dialog-title="Are you sure to delete this plan?"
    ).mt-3
      td.pl-4.w-50 {{ item.id }}
      td.pl-4 {{ item.name }}
      td.pl-4 {{ item.price }}
      td.pl-4 {{ item.duration }}
    plan-modal(
      :value="isModalVisible"
      @input="hideModal"
      @closeModal="hideModal"
      @itemCreated="loadList"
      @itemUpdated="loadList"
      :itemModel="planModel"
      :editMode="isEditMode"
    )
</template>

<script>
import ErrorMixin from "@/mixins/errors.mixin"
import {PaymentsService} from "../core/payments-service";
import {OrdersSortingModel} from "@/app/exercise/modules/payments/core/models/OrdersSortingModel";
import {PlansSortingModel} from "@/app/exercise/modules/payments/core/models/PlansSortingModel";

export default {
  components: {
    list: () => import('@/app/exercise/components/ItemsList'),
    planModal: () => import('./PlanModal.vue'),
  },

  data() {
    return {
      sortModel: null,
      svc: null,
      list: [],
      listLoading: false,
      pagination: null,
      isModalVisible: false,
      isEditMode: false,
      planModel: {},
      headers: [
        { text: 'ID', align: 'left', class: 'pl-4 w-50', value: 'id', sortable: true},
        { text: 'Name', align: 'left', class: 'pl-4', value: 'name', sortable: true},
        { text: 'Price (€)', align: 'left', class: 'pl-4', value: 'price', sortable: true},
        { text: 'Duration (days)', align: 'left', class: 'pl-4', value: 'duration', sortable: true},
        { text: 'Actions', align: 'center', class: "w-100 pr-4", sortable: false }
      ],
    }
  },

  mixins: [ErrorMixin],

  created() {
    this.init()
  },

  async mounted() {
    this.pagination = {
      page: 1
    };

    this.loadList();
  },

  watch: {
    sortModel: {
      deep: true,
      handler() {
        this.loadList();
      }
    }
  },

  methods: {
    init() {
      this.svc = new PaymentsService(this.$auth);
      this.sortModel = new PlansSortingModel(this.$route.query);
    },

    hideModal() {
      this.isModalVisible = false;
      this.isEditMode = false;
      this.planModel = {};
    },

    async deletePlan(plan) {
      try {
        await this.svc.removePlan(plan.id);
        this.loadList();
      } catch (error) {
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors,
          apiAttributes: plan._apiAttributes
        });
      }
    },

    showPlanModal() {
      this.isModalVisible = true
    },

    editPlan(plan) {
      this.showPlanModal();
      this.planModel = plan;
      this.isEditMode = true;
    },

    async loadList() {
      try {
        this.listLoading = true;
        const query = { ...this.pagination, ...this.sortModel.getApiData() };
        let { results, pagination } = await this.svc.loadPlans(query);
        this.pagination = pagination;
        this.list = results || [];
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },

    async loadListMore(page) {
      try {
        this.listLoading = true;
        let { results } = await this.svc.loadPlans({
          page
        });
        this.list.push(...results);
        this.listLoading = false;
      } catch (error) {
        this.listLoading = false;
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE});
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .plans {
    .v-card {
      .body {
        height: 100vh;
        max-height: calc(100vh - 90px);
        overflow: auto;
        &.inner-scroll {
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
      }
    }

    .w-100 {
      width: 100px;
    }
    .w-300 {
      width: 300px;
    }
    .w-50 {
      width: 50px;
    }
  }
</style>

